export const joinArrayToString = (arr, separator = ", ") => {
  return arr.filter((i) => i).join(separator);
};

export const formatMessage = (template, ...args) =>
  template.replace(/{(\d+)}/g, (s, num) => args[num]);

export const removeWhiteSpace = (str) => str.replace(/\s+/g, "");

export const removeSpecialCharacters = (str) => str.replace(/[^\w\s\\*]/gi, "");
